import { Dispatch, SetStateAction, useState } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import RefreshIcon from '@mui/icons-material/Refresh'

import { ArchivedPlanningsSwitch } from './ArchivedPlanningsSwitch'
import { RefreshButton } from './RefreshButton'

type PlanningDashboardActionsProps = {
  isRefreshing: boolean
  onRefresh: () => Promise<void> | void
  setShowArchived: Dispatch<SetStateAction<boolean>>
  showArchived: boolean
}

export function PlanningDashboardActions({ isRefreshing, onRefresh, setShowArchived, showArchived }: PlanningDashboardActionsProps) {
  useLingui()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  if (!isMobile) {
    return (
      <Stack direction="row" alignItems="center" justifyContent="end" spacing={2}>
        <ArchivedPlanningsSwitch showArchived={showArchived} setShowArchived={setShowArchived} />
        <RefreshButton isRefreshing={isRefreshing} onClick={onRefresh} />
      </Stack>
    )
  }

  return (
    <>
      <Tooltip title={t`More Actions`}>
        <IconButton
          aria-label={t`More Actions`}
          data-testid="planning-dashboard-actions-menu"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          size="small"
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
        <MenuItem disableRipple onClick={(event) => event.stopPropagation()}>
          <ArchivedPlanningsSwitch showArchived={showArchived} setShowArchived={setShowArchived} />
        </MenuItem>
        <MenuItem
          disabled={isRefreshing}
          onClick={() => {
            setAnchorEl(null)
            void onRefresh()
          }}
        >
          <ListItemIcon>
            <RefreshIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t`Refresh`}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}
